export default __webpack_public_path__ + "static/media/slogan_vert_center_small.c3137b08.png";